import React, { useEffect, useState } from 'react';
import { Alert } from "react-bootstrap";
import { ErrorComponent } from '../ErrorComponent';
import { Icon } from '../ui/Icon';

export interface UpdateResult {
    data?: any;
    error?: any;
    isUninitialized: boolean // Mutation has not been fired yet
    isLoading: boolean // Mutation has been fired and is awaiting a response
    isSuccess: boolean // Mutation has data from a successful call
    isError: boolean // Mutation is currently in an "error" state
}

interface UpdateResultComponentProps {
   result: UpdateResult
   success: string
   error: string
   delay?: number;
   label: string;
}

export const UpdateResultComponent: React.FC<UpdateResultComponentProps> = (props) => {
    
    const [show, setShow] = useState(true);

    useEffect(()=>{
        console.log(props.result);
        setShow(true);
        setTimeout(()=> setShow(false), props.delay ?? 10000);
    }, [props.result, props.delay]); // Empty deps to ensure it's run only once
    
    const Message = ()=> {
        return <React.Fragment>
            {props.result.isSuccess ? <Alert variant='success' onClose={() => setShow(false)} dismissible>{props.success}</Alert> : ''}
            {props.result.isError ? <Alert variant='danger' onClose={() => setShow(false)} dismissible><b>{props.error}</b><ErrorComponent error={props.result.error}/></Alert> : ''}
        </React.Fragment>;
    };
    if(show) {
        return <Message/>;
    }

    const icon = (result:UpdateResult) => {
        if(!result || result.isUninitialized) {
            return <span/>;
        }
        if(result.isLoading) {
            return <Icon name="sync"/>;
        }
        const n = result.isSuccess ? 'check' : 'exclamation-circle';
        const v = result.isSuccess ? 'success' : 'danger';
        return <span onClick={() => setShow(true)} title={props.label}> <Icon name={n} className={ 'text-' + v } /></span>;
    }
    return icon(props.result);
}